import React, {  useState, useEffect } from 'react';

const PrivacyPolicy = (props) => {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    fetch('/privacy-policy.html')
    .then((response) => response.text())
    .then((data) => setHtmlContent(data))
    .catch((error) => console.error('Error loading HTML:', error));
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  )
};

export default PrivacyPolicy;
